import { lazy } from 'react';

export const SecretKeyCongratulationsLazy = lazy(
  () => import('./SecretKeyCongratulations')
);
